// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { configFetchedSelector } from '../../../selectors/configSelectors';
import LoggedIn from '../LoggedIn';
import type { Props } from '../LoggedIn';

const mapStateToProps = (state: State) => {
    return {
        configFetched: configFetchedSelector(state)
    };
};

export default connect<Props, *, _, _, _, _>(mapStateToProps)(LoggedIn);